export const ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD =
  'ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD'
export const ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD_PENDING =
  'ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD_PENDING'
export const ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD_FULFILLED =
  'ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD_FULFILLED'
export const ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD_REJECTED =
  'ONBOARDING_HR_INDUSTRY_TEMPLATES_LIST_LOAD_REJECTED'
